import React from 'react';
import classnames from 'classnames/bind';
import { IndicationContent, INDICATION_TYPES } from 'taboola-ultimate-ui';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './uploadMediaError.module.scss';

const classNameBuilder = classnames.bind(styles);

export const UploadMediaError = ({ errorMessageId, className }) => {
    return errorMessageId ? (
        <IndicationContent containerClassName={classNameBuilder('error', className)} type={INDICATION_TYPES.ERROR}>
            <FormattedMessage id={errorMessageId} defaultMessage="Upload Error" />
        </IndicationContent>
    ) : null;
};
